import request from './request';

export const authApi = {
  login: (data) => request.post('/auth/login', data),
  getCaptcha: () => request.get('/auth/captcha')
};

export const adminApi = {
  dashboard: () => request.get('/admin/dashboard'),
  listBloggers: (params) => request.get('/admin/bloggers', { params }),
  auditBlogger: (id, data) => request.put('/admin/bloggers/' + id + '/audit', data),
  updateBloggerStatus: (id, data) => request.put('/admin/bloggers/' + id + '/status', data),
  resetPassword: (id) => request.post('/admin/bloggers/' + id + '/reset-password'),
  listUsers: (params) => request.get('/admin/users', { params }),
  updateUserStatus: (id, data) => request.put('/admin/users/' + id + '/status', data),
  listResources: (params) => request.get('/admin/resources', { params }),
  updateConfig: (data) => request.put('/admin/config', data)
};

export const withdrawApi = {
  pending: (params) => request.get('/withdraw/pending', { params }),
  getDetail: (id) => request.get('/withdraw/' + id),
  approve: (id, data) => request.post('/withdraw/' + id + '/approve', data),
  reject: (id, data) => request.post('/withdraw/' + id + '/reject', data),
  all: (params) => request.get('/withdraw/all', { params })
};

export const resourceApi = {
  forceRemove: (id) => request.put('/resources/' + id + '/force-remove')
};
